<div class="modal-header" mat-dialog-title>
    <h5 class="modal-title">{{ (dailogData.title) ? dailogData.title : 'Add Image'}}</h5>
    <a class="modal-close" mat-dialog-close>&#10005;</a>
</div>
<mat-dialog-content class="mat-add-image-error">
    <div class="modal-body">
        <p class="unexprected-error">We are sorry, an unexpected error occurred while submitting your request.</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" align="start">
    <button mat-button class="save-btn" (click)="onClickTryAgain()">Please Try Again </button>
</mat-dialog-actions>